import { createContext } from 'react'

export interface User {
  id: number
  email: string
  firstName: string
  lastName: string
  isAdmin: boolean
  role: 'ADHERENT' | 'SENSEI'
  beltLevel: string
}

export interface AuthContextValue {
  user: User | null
  token: string | null
  login: (email: string, password: string) => Promise<User>
  logout: () => void
  updateUser: (userData: Partial<User>) => void
  loading: boolean
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
